import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseRemoveShopLogoParams = {
	shopId: string;
};

export default function useRemoveShopLogo({ shopId }: UseRemoveShopLogoParams) {
	const invalidateShop = useInvalidateShop(shopId);

	return useApiMutation<"delete", "/shops/{shopId}/logo", void>(
		"delete",
		"/shops/{shopId}/logo",
		{
			invalidate: invalidateShop,
			mapVariables: () => ({
				params: { path: { shopId } },
			}),
		},
	);
}
